import { useEffect, useState } from 'react';

/**
 * 指定ミリ秒数待機
 * @param ms
 * @returns
 */
export function sleep(ms = 1000) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

/**
 * CSSクラス名配列をClassNameの形式に変換する
 * @param classList CSSクラス名配列
 * @returns ClassName
 */
export function cvtClassName(classList: Array<string>) {
  return classList.join(' ');
}

/**
 * 日付クラスを文字列に変換する
 * @param dt 日付クラス
 * @returns 文字列化した日付
 */
export function cvtDate(dt: Date) {
  return dt
    .toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    .replace(/\//g, '.');
}

/**
 * 日付クラスを文字列に変換する
 * @param dt 日付クラス
 * @returns 文字列化した日付+時間
 */
export function cvtDatetime(dt: Date) {
  return dt
    .toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
    .replace(/\//g, '.');
}

/**
 * スマホサイズ判定
 * @returns
 */
export function device() {
  const { userAgent: ua } = window.navigator;
  if (ua.match(/iPhone|Android.+Mobile/)) {
    return 'sp';
  } else if (ua.match(/iPad|Android/)) {
    return 'tablet';
  } else {
    return 'pc';
  }
}

export const MediaQueryEnum = {
  sp: '(max-width: 751px)',
  tablet: '(min-width: 752px) and (max-width: 1121px)',
  pc: '(min-width: 1122px)',
};

export const useMediaQuery = (query: string) => {
  const formattedQuery = `(${query})`;
  const [match, setMatch] = useState(matchMedia(formattedQuery).matches);

  useEffect(() => {
    const mql = matchMedia(formattedQuery);

    if (mql.media === 'not all' || mql.media === 'invalid') {
      console.error(`useMediaQuery Error: Invalid media query`);
    }

    mql.onchange = (e) => {
      setMatch(e.matches);
    };

    return () => {
      mql.onchange = null;
    };
  }, [formattedQuery, setMatch]);

  return match;
};

/**
 * ファイル名をランダムな16進数12桁に変換
 * @param fileName 元のファイル名
 * @returns サニタイズされたファイル名（例: "a3f5e8b2c14d.mp4"）
 */
export function sanitizeFileName(fileName: string): string {
  // ランダムな16進数12桁を生成
  const randomHex = Array.from({ length: 12 }, () =>
    Math.floor(Math.random() * 16).toString(16)
  ).join('');

  // 拡張子を取得
  const lastDotIndex = fileName.lastIndexOf('.');
  const extension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : '';

  return `${randomHex}${extension}`;
}
